const XLSX_MIME: string =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/** Dispara la descarga de un blob en el navegador y libera la URL temporal */
export const downloadBlob = (params: { blob: Blob; fileName: string }): void => {
  const { blob, fileName } = params;
  const url: string = URL.createObjectURL(blob);
  const anchor: HTMLAnchorElement = document.createElement("a");

  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

/**
 * Convierte el excel que llega en base64 dentro del json a un blob descargable.
 * El backend responde el archivo en base64 justamente para que la descarga la
 * dispare el usuario con un boton y no ocurra al terminar la carga.
 */
export const downloadBase64Excel = (params: {
  base64: string;
  fileName: string;
}): void => {
  const { base64, fileName } = params;
  const binary: string = atob(base64);
  const buffer: ArrayBuffer = new ArrayBuffer(binary.length);
  const bytes: Uint8Array = new Uint8Array(buffer);

  for (let index = 0; index < binary.length; index++) {
    bytes[index] = binary.charCodeAt(index);
  }

  downloadBlob({ blob: new Blob([buffer], { type: XLSX_MIME }), fileName });
};

/** Extrae el nombre de archivo del header `Content-Disposition` */
export const getFileNameFromDisposition = (params: {
  disposition: string | undefined;
  fallback: string;
}): string => {
  const { disposition, fallback } = params;
  if (!disposition) return fallback;

  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
  if (!match?.[1]) return fallback;

  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};
